<ng-container *ngIf="progress">
  <h3>Last EHM run</h3>
  <app-table [useFixedHeader]="false">
    <app-table-headers>
      <app-table-header class="flex">Pro Account ID</app-table-header>
      <app-table-header class="flex-half">Section ID</app-table-header>
      <app-table-header class="flex-center">Status</app-table-header>
      <ng-container *ngFor="let eventType of eventTypes">
        <app-table-header
          class="flex"
          *ngIf="getEventType(eventType).shouldBeProcessed !== undefined"
        >
          {{ splitOnUppercase(eventType) | titlecase }}
        </app-table-header>
      </ng-container>
    </app-table-headers>
    <app-table-content *ngIf="progress">
      <app-table-row>
        <app-table-cell class="flex">
          <strong>
            {{ progress?.proAccountID }}
          </strong>
        </app-table-cell>
        <app-table-cell class="flex-half">
          <strong>
            {{ progress?.sectionID }}
          </strong>
        </app-table-cell>
        <app-table-cell class="flex-center">
          <span
            [ngClass]="
              'badge badge-' + getMigrationStateClass(progress?.migrationState)
            "
          >
            {{ progress?.migrationState }}
          </span>
          <button
            *ngIf="progress.migrationState === MigrationState.InProgress"
            (click)="
              updateProgress(
                progress.proAccountID,
                progress.oneAccountID,
                progress.sectionID
              )
            "
            class="btn btn-sm"
          >
            <i class="fas fa-sync" [class.spinner]="progressIsLoading"></i>
          </button>
          <p class="bo-progress-bar">
            <ngb-progressbar
              type="success"
              [showValue]="true"
              [value]="
                progress?.migrationState === MigrationState.Success
                  ? 100
                  : percentage(progress.events)
              "
            >
            </ngb-progressbar>
          </p>
        </app-table-cell>
        <ng-container *ngFor="let eventType of eventTypes">
          <app-table-cell
            class="flex"
            *ngIf="getEventType(eventType).shouldBeProcessed !== undefined"
          >
            <ng-container
              *ngIf="
                !getEventType(eventType)?.shouldBeProcessed;
                else processBounceEvent
              "
            >
              <p>N/A</p>
            </ng-container>
            <ng-template #processBounceEvent>
              <p>
                <b>Processed:</b>
                {{ formatEvents(getEventType(eventType).processedEvents) }}
              </p>
              <p>
                <b>Expected:</b>
                {{ formatEvents(getEventType(eventType).totalEvents) }}
              </p>
            </ng-template>
          </app-table-cell>
        </ng-container>
      </app-table-row>
    </app-table-content>
  </app-table>
</ng-container>
